export default "__VITE_ASSET__BG3oFKtV__"